<template>
	<div class="drawer">
		<el-drawer
		size="400px"
		:visible.sync="drawerStatus"
		@close='handleClose'
		:append-to-body="true"
		>
			<img src="../../../../assets/img/remark.png" style="width:200px;display: block;margin:150px auto 80px;"/>
			<el-form :inline="true" class="form">
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="24">
							<el-form-item label="备注:" :label-width="formLabelWidth">
								<el-input v-model="remark" type="textarea" :rows="5" style="width:300px;" placeholder="请录入备注"></el-input>
							</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="handleClose">取消</div>
				<div class="btnItem submit" @click="submitCode">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth:'60px',
				remark:'',
			}
		},
		computed:{
			remark1(){
				return this.$store.state[this.type].remark;
			},
		},
		props:{
			type:{
				default:''
			}
		},
		mounted(){
			this.remark = this.remark1;
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			submitCode(){
				this.$store.commit(this.type+"/set_remark",this.remark)
				this.$emit('submit',{type:'close'})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.form{
				::v-deep .el-form-item{
					margin:5px 0;
				}
			}
		}
		
	}
	.btnBox{
		width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
		.btnItem{
			text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
			&.submit{
				background-color: $mainColor;
			}
		}
	}
</style>
